import React from "react";
import Modal from "../../ui/modal";
import Button from "../../ui/button";
import styles from "./unsaved-changes-modal.module.css";

const UnsavedChangesModal = ({ isOpen, onCancel, onConfirm, message }) => {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} title="Cambios sin guardar">
      <div className={styles.content}>
        <p className={styles.message}>
          {message || "¿Estás seguro de que quieres salir? Los cambios no guardados se perderán."}
        </p>
        <div className={styles.actions}>
          <Button onClick={onCancel} variant="secondary">
            Cancelar
          </Button>
          <Button onClick={onConfirm} variant="danger">
            Salir sin guardar
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UnsavedChangesModal;
